/**
 * @file: CanteenEmergency.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 餐厅应急处理
 */
import request from '@/utils/request'

/**
 * 小程序-获取餐厅应急处理方案(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function emergencyCanteenemergencyAppletEmergencyGet(data) {
  return request({
    type: 'biz',
    url: 'emergency/canteenEmergency/applet/emergency/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-打开/关闭应急处理(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function emergencyCanteenemergencyAppletEmergencyStatusUpdate(data) {
  return request({
    type: 'biz',
    url: 'emergency/canteenEmergency/applet/emergency/status/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/CanteenEmergency.js